// extracted by mini-css-extract-plugin
export default {"hand":"AssetsScreen_hand__sQQVb","container":"AssetsScreen_container__35gcE"};